import { useMutation } from "@apollo/client";
// import { CREATE_ORDER } from "../graphql/mutations/mutations";
import { CreateOrder, CreateOrderVariables } from "_graphql/mutation/__generated__/CreateOrder";
import { createOrder as createOrderMutation } from "_graphql/mutation/order";


export const useCreateOrder = () => {
    const [createOrder, { loading, error }] = useMutation<CreateOrder, CreateOrderVariables>(createOrderMutation, {

    });

    return {
        createOrder,
        loading, error
    }
};
